import { DisplayMeasurementProfileDetail } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export default function useDisplayMeasurementProfileDetail(profilId: string | undefined) {
  const { geotabClient } = useGeotabClient();
  return useQuery({
    queryKey: ["displayMeassurementProfile", profilId],

    queryFn: ({ signal }): Promise<DisplayMeasurementProfileDetail[]> => {
      if (!profilId) {
        return Promise.resolve([]);
      }
      return geotabClient.call(
        "Get",
        {
          typeName: "DisplayMeasurementProfileDetail",
          search: {
            displayMeasurementProfileSearch: { id: profilId },
          },
        },
        signal,
      );
    },
  });
}
